import React, { useEffect, useState } from 'react';
import './PasswordResetPage.scss';
import { useMutation } from '@apollo/client';
import { Link } from 'gatsby';
import { customerRecover } from '../../../components/shared/mutation/mutation.js';

export default (function RegisterPage(props) {
  const [formField, setFormField] = useState({
    email: '',
  });
  const [customerRecoverQuery, { data: customerRecoverData, error: customerRecoverError }] = useMutation(
    customerRecover,
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (customerRecoverError) {
      console.log(customerRecoverError);
    }
    if (customerRecoverData) {
      if (customerRecoverData.customerRecover.customerUserErrors.length > 0) {
        alert(customerRecoverData.customerRecover.customerUserErrors[0].message);
      } else {
        alert('E-Mail zur Wiederherstellung erfolgreich gesendet');
      }
    }
  }, [customerRecoverData, customerRecoverError]);

  function handleConfirm() {
    if (formField.email === '' || formField.password === '') {
      alert('Leeres E-Mail- oder Passwortfeld');
      return;
    }
    customerRecoverQuery({
      variables: {
        email: formField.email,
      },
    });
  }

  return (
    <div className="mainLoginRegisterPage">
      <div className="cus_sign_container">
        <h2 className="sign_bg_tt">Wiederherstellen</h2>
        <div className="custom_signin">
          <div className="cus_page-content">
            <div className="cus_grid__item">
              <div className="login_img">
                <img
                  className="lazyload"
                  srcSet="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_100x.png?v=1585121200 100w,
                                            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_200x.png?v=1585121200 200w,
                                            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_400x.png?v=1585121200 400w,
                                            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_800x.png?v=1585121200 800w,
                                            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_1600x.png?v=1585121200 1600w,"
                  alt="GOBI CASHMERE"
                />
              </div>
            </div>
          </div>

          <div className="cus_page-content">
            <div className="cus_grid__item">
              <header className="section-header">
                <h1 className="section-header__title">ANMELDEN</h1>
              </header>
              <span className="req_tt">
                Neuer Nutzer?{' '}
                <Link style={{ color: '#46A3F9', fontWeight: '600' }} to="/account/register">
                  {' '}
                  Ein Konto erstellen
                </Link>
              </span>

              <div id="RecoverPasswordForm">
                <form className="form-vertical">
                  <h2 style={{ textAlign: 'center' }}>Ihr Passwort zurücksetzen</h2>
                  <p style={{ textAlign: 'center', marginBottom: '10px' }}>
                    Wir schicken Ihnen eine E-Mail mit einem Link, mit dem Sie ihr Passwort zurücksetzen können.
                  </p>
                  <label htmlFor="Email" style={{ marginBottom: '5px' }}>
                    E-Mail *
                  </label>
                  <input
                    style={{ marginTop: '5px' }}
                    placeholder="Email"
                    type="email"
                    name="customer[email]"
                    id="Email"
                    className="input-full"
                    autoCorrect="off"
                    autoCapitalize="off"
                    onChange={(event) => {
                      setFormField({
                        ...formField,
                        ...{ email: event.target.value },
                      });
                    }}
                  />
                  <div className="cus_btn">
                    <input type="button" onClick={handleConfirm} value="Senden" className="btn login_cus_btn" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
